var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 yo-align-center white"},[_vm._v(" Società Italiana di Pediatria E.T.S. - Via Cavour 58 - 00184 Roma - Codice Fiscale 96147720583 Partita IVA 06299590965 ")])])])
}]

export { render, staticRenderFns }